import AxiosAuth2 from "../../services/axios-service-auth";

const addEASIHeadScores = (data) => {
  return AxiosAuth2.post("/api/easiScore/saveEasiScore", data, undefined);
};

const savePasiScore = (data) => {
  return AxiosAuth2.post("/api/nih/pasiScore/savePasiScore", data, undefined);
};

const saveFlarePasiScore = (data) => {
  return AxiosAuth2.post("/api/flareScoring/savePasiEasiScore", data, undefined);
};

const getEasiTotal = (month,patientId) => {
  return AxiosAuth2.get("/api/easiScore/getEasiScore?month="+month+"&patientId="+patientId, undefined, undefined);
};

const getEasiScoreForJanssen = (week,patientId) => {
  return AxiosAuth2.get("/api/easiScore/getEasiScoreForJanssen?week="+week+"&patientId="+patientId, undefined, undefined);
};

const getEasiScoreForNih = (month,week,patientId,studyId) => {
  return AxiosAuth2.get("/api/nih/pasiScore/getPasiScore?month="+month+"&week="+week+"&patientId="+patientId+"&studyId="+studyId, undefined, undefined);
};

const getFlareEasiScores = (date,patientId) => {
  return AxiosAuth2.get("/api/flareScoring/getTotalPasiEasiScore?date="+date+"&patientId="+patientId, undefined, undefined);
};

const getScoresNih = (userId,week,month,partType,studyId) => {
  return AxiosAuth2.get("/api/nih/pasiScore/getPasiForUserScore?userId="+userId+"&week="+week+"&month="+month+"&partType="+partType+"&studyId="+studyId, undefined, undefined);
};

const getPartsTotalScore = (userId,date,partType) => {
  return AxiosAuth2.get("/api/flareScoring/getPasiEasiScoreForUser?userId="+userId+"&date="+date+"&partType="+partType, undefined, undefined);
};

const getGlobalAssessment = (month,patientId) => {
  return AxiosAuth2.get("/api/globalAssessment/getGlobalAssessment?month="+month+"&patientId="+patientId, undefined, undefined);
};

const getGlobalAssessmentForJanssen = (week,patientId) => {
  return AxiosAuth2.get("/api/globalAssessment/getGlobalAssessmentForJanssen?week="+week+"&patientId="+patientId, undefined, undefined);
};

const getGlobalAssessmentForNewJanssen = (week,patientId) => {
  return AxiosAuth2.get("/api/globalAssessment/getGlobalAssessmentForNewJanssen?week="+week+"&patientId="+patientId, undefined, undefined);
};

const getGlobalAssessmentForNih = (month,patientId) => {
  return AxiosAuth2.get("/api/globalAssessment/getGlobalAssessment?month="+month+"&patientId="+patientId, undefined, undefined);
};

const getFlareGlobalAssessment = (date,patientId) => {
  return AxiosAuth2.get("/api/flareScoring/getFlareGlobalAssessment?date="+date+"&patientId="+patientId, undefined, undefined);
};

const saveGlobalAssessment = (data) => {
  return AxiosAuth2.post("/api/globalAssessment/SaveGlobalAssessment", data, undefined);
};

const saveFlareGlobalAssessment = (data) => {
  return AxiosAuth2.post("/api/flareScoring/saveGlobalAssessment", data, undefined);
};

export default {
    addEASIHeadScores,
    getEasiTotal,
    getGlobalAssessment,
    saveGlobalAssessment,
    getEasiScoreForJanssen,
    getGlobalAssessmentForJanssen,
    savePasiScore,
    getEasiScoreForNih,
    getScoresNih,
    getGlobalAssessmentForNih,
    saveFlarePasiScore,
    getPartsTotalScore,
    getFlareEasiScores,
    getFlareGlobalAssessment,
    saveFlareGlobalAssessment,
    getGlobalAssessmentForNewJanssen
};
